import { RouteType } from "types/RouteType";
import fieldOverviewRoutes, {
  fieldReportingPanelsRoute,
  fieldReportingHardwareRoute,
  // fieldActivityHistoryRoute, // Commented out until components are created
} from "./FieldReporting.Route";
import jobFieldReportingRoute from "./JobFieldReporting/JobFieldReporting.Route";

const fieldReportingRoutesList: RouteType[] = [
  fieldOverviewRoutes,
  jobFieldReportingRoute,
  fieldReportingPanelsRoute,
  fieldReportingHardwareRoute,
  // fieldActivityHistoryRoute, // Commented out until components are created
];

export default fieldReportingRoutesList;